"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const responseError = require("./common/responseError");
const app_1 = require("./app");
const identifiers_1 = require("./identifiers");
const getUsers_1 = require("./getUsers");
const loginWithEmail_1 = require("./loginWithEmail");
const storeToken_1 = require("./storeToken");
const signupWithEmail_1 = require("./signupWithEmail");
function loginWithUidOrEmail(userId, userEmail, userPassword) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const email = userId ? userId + '@playpowerlabs.com' : userEmail;
            const password = userId ? userId + 'playpower' : userPassword;
            const userDoc = yield getUsers_1.default({ email });
            if (userDoc.length) {
                return yield loginWithEmail_1.default({
                    email,
                    password,
                    role: identifiers_1.Types.UserPermissionRoles.STUDENT
                });
            }
            else {
                if (userId) {
                    const data = yield app_1.app.auth.createUserWithEmailAndPassword(email, password);
                    const { displayName, providerData, refreshToken, uid } = data.user;
                    const usersRef = app_1.app.firestore.collection(`users`);
                    const insertObj = {
                        name: displayName,
                        email,
                        providerIds: { email: uid },
                        permissions: [
                            {
                                domainId: '',
                                role: identifiers_1.Types.UserPermissionRoles.STUDENT
                            }
                        ],
                        password,
                        googleAuthRefreshToken: ''
                    };
                    const response = yield usersRef.doc(userId).set(insertObj);
                    const tokenData = {
                        refreshToken,
                        uid,
                        name: displayName,
                        email,
                        domainId: '',
                        providerId: providerData[0].providerId,
                        role: identifiers_1.Types.UserPermissionRoles.STUDENT
                    };
                    return yield storeToken_1.default(tokenData, password);
                }
                else {
                    return yield signupWithEmail_1.default({
                        email,
                        password,
                        role: identifiers_1.Types.UserPermissionRoles.STUDENT
                    });
                }
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.email_already_exists, e.message);
        }
    });
}
exports.default = loginWithUidOrEmail;
//# sourceMappingURL=loginWithUidOrEmail.js.map